// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RadioButton__root--bMfgD {
    display: flex;
    align-items: center;
    gap: 4px;
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
    padding: 11px 14px;
    border-radius: 306px;
    border: 1px solid var(--dark-secondary-new-color);
    transition: 0.25s background-color ease-in-out;
    color: var(--tertiary-color);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
}

    @media (hover: hover) and (pointer: fine) {
        .RadioButton__root--bMfgD:hover {
            background-color: var(--dark-secondary-new-color);
        }
    }

    .RadioButton__root--bMfgD.RadioButton__checked--ybZ4m {
        background-color: var(--dark-secondary-new-color);
    }

    .RadioButton__root--bMfgD.RadioButton__checked--ybZ4m .RadioButton__checkmark--bkqbs {
            border-color: var(--main-color);
        }

    .RadioButton__root--bMfgD.RadioButton__checked--ybZ4m .RadioButton__checkmark--bkqbs:after {
                background-color: var(--main-color);
            }

    .RadioButton__root--bMfgD:not(.RadioButton__checked--ybZ4m).RadioButton__disabled--OCf3c {
        opacity: 0.2;
        pointer-events: none;
    }

    @media screen and (min-width: 1024px) {.RadioButton__root--bMfgD {
        font-size: 16px;
        padding: 12px 16px;
        gap: 8px
}
    }

    .RadioButton__root--bMfgD.RadioButton__secondary--Ez_AH {
        font-size: 12px;
        font-weight: 600;
        line-height: 2;
        letter-spacing: 0.6px;
        border-radius: 6px;
        text-transform: uppercase;
        padding: 12px 14px;
    }

    .RadioButton__root--bMfgD.RadioButton__secondary--Ez_AH.RadioButton__withIcon--mBlT5 .RadioButton__checkmark--bkqbs {
            width: 20px;
            height: 20px;
            border-radius: 3px;
            padding: 1px; 
        }

    .RadioButton__root--bMfgD.RadioButton__secondary--Ez_AH.RadioButton__withIcon--mBlT5 .RadioButton__checkmark--bkqbs svg {
                width: 16px;
                height: 16px;
                color: var(--main-color);
            }

    .RadioButton__root--bMfgD.RadioButton__secondary--Ez_AH.RadioButton__withIcon--mBlT5 .RadioButton__checkmark--bkqbs:after {
                display: none;
            }

    @media screen and (max-width: 375px) {

    .RadioButton__root--bMfgD.RadioButton__secondary--Ez_AH {
            padding: 12px 10px
    }
        }
  
input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.RadioButton__checkmark--bkqbs {
    background-color: #eee;
    border-radius: 50%;
    position: relative;
    border: 1px solid var(--dark-tertiary-new-color);
    background-color: var(--dark-primary-new-color);
    padding: 3px;
    transition: 0.25s border-color ease-in-out;
}

.RadioButton__checkmark--bkqbs:after {
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    transition: 0.25s background-color ease-in-out;
    background-color: var(--dark-tertiary-new-color);
}`, "",{"version":3,"sources":["webpack://./src/components/RadioButton/RadioButton.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,eAAe;IACf,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,iDAAiD;IACjD,8CAA8C;IAC9C,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AA6DrB;;IA3DI;QACI;YACI,iDAAiD;QACrD;IACJ;;IAEA;QACI,iDAAiD;IASrD;;IAPI;YACI,+BAA+B;QAKnC;;IAHI;gBACI,mCAAmC;YACvC;;IAIR;QACI,YAAY;QACZ,oBAAoB;IACxB;;IAEA,uCAvCJ;QAwCQ,eAAe;QACf,kBAAkB;QAClB;AAiCR;IAhCI;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,qBAAqB;QACrB,kBAAkB;QAClB,yBAAyB;QACzB,kBAAkB;IAsBtB;;IApBI;YACI,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,YAAY;QAWhB;;IATI;gBACI,WAAW;gBACX,YAAY;gBACZ,wBAAwB;YAC5B;;IAEA;gBACI,aAAa;YACjB;;IAGJ;;IA1BJ;YA2BQ;IAER;QADI;;AAIR;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gDAAgD;IAChD,+CAA+C;IAC/C,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,8CAA8C;IAC9C,gDAAgD;AACpD","sourcesContent":[".root {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    position: relative;\n    cursor: pointer;\n    user-select: none;\n    padding: 11px 14px;\n    border-radius: 306px;\n    border: 1px solid var(--dark-secondary-new-color);\n    transition: 0.25s background-color ease-in-out;\n    color: var(--tertiary-color);\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background-color: var(--dark-secondary-new-color);\n        }\n    }\n\n    &.checked {\n        background-color: var(--dark-secondary-new-color);\n\n        .checkmark {\n            border-color: var(--main-color);\n\n            &:after {\n                background-color: var(--main-color);\n            }\n        }\n    }\n\n    &:not(.checked).disabled {\n        opacity: 0.2;\n        pointer-events: none;\n    }\n\n    @media (--large) {\n        font-size: 16px;\n        padding: 12px 16px;\n        gap: 8px;\n    }\n\n    &.secondary {\n        font-size: 12px;\n        font-weight: 600;\n        line-height: 2;\n        letter-spacing: 0.6px;\n        border-radius: 6px;\n        text-transform: uppercase;\n        padding: 12px 14px;\n\n        &.withIcon .checkmark {\n            width: 20px;\n            height: 20px;\n            border-radius: 3px;\n            padding: 1px;\n\n            svg {\n                width: 16px;\n                height: 16px;\n                color: var(--main-color);\n            }\n\n            &:after {\n                display: none;\n            } \n        }\n\n        @media screen and (max-width: 375px) {\n            padding: 12px 10px;\n        }\n    }\n}\n  \ninput {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n}\n\n.checkmark {\n    background-color: #eee;\n    border-radius: 50%;\n    position: relative;\n    border: 1px solid var(--dark-tertiary-new-color);\n    background-color: var(--dark-primary-new-color);\n    padding: 3px;\n    transition: 0.25s border-color ease-in-out;\n}\n\n.checkmark:after {\n    content: '';\n    display: block;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    transition: 0.25s background-color ease-in-out;\n    background-color: var(--dark-tertiary-new-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `RadioButton__root--bMfgD`,
	"checked": `RadioButton__checked--ybZ4m`,
	"checkmark": `RadioButton__checkmark--bkqbs`,
	"disabled": `RadioButton__disabled--OCf3c`,
	"secondary": `RadioButton__secondary--Ez_AH`,
	"withIcon": `RadioButton__withIcon--mBlT5`
};
export default ___CSS_LOADER_EXPORT___;
